import {
  $createTextNode,
  ElementNode,
  RangeSelection,
  TextNode,
} from 'lexical';
import { $isAtNodeEnd } from '@lexical/selection';

export function getSelectedNode(
  selection: RangeSelection,
): TextNode | ElementNode {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorNode = selection.anchor.getNode();
  const focusNode = selection.focus.getNode();
  if (anchorNode === focusNode) {
    return anchorNode;
  }
  const isBackward = selection.isBackward();
  if (isBackward) {
    return $isAtNodeEnd(focus) ? anchorNode : focusNode;
  } else {
    return $isAtNodeEnd(anchor) ? focusNode : anchorNode;
  }
}

export function moveForwardOrCreateNextNode(sel: RangeSelection) {
  const node = getSelectedNode(sel);
  const nextNode = node.getNextSiblings()[0];

  if (nextNode) {
    sel.anchor.set(nextNode.getKey(), 1, 'text');
    sel.focus.set(nextNode.getKey(), 1, 'text');
  } else {
    sel.insertNodes([$createTextNode(' ')]);
  }
}

export interface Rect {
  top: number;
  left: number;
  bottom: number;
  right: number;
  height: number;
  width: number;
}

export const initRect: Rect = {
  top: NaN,
  left: NaN,
  bottom: NaN,
  right: NaN,
  height: NaN,
  width: NaN,
};

export function getRectFromSelection(selection: Selection | null): Rect {
  if (!selection) {
    return initRect;
  }

  if (selection.rangeCount < 1) {
    return initRect;
  }
  const range = selection.getRangeAt(0);
  const { height, width, top, left, right, bottom } =
    range.getBoundingClientRect();

  const editor = document.querySelector('.iva-editor')!;
  const rect = editor.getBoundingClientRect();
  console.log(rect);

  return {
    height,
    width,
    top,
    left,
    right,
    bottom,
  };
}
